import ManageCheckerInbox from "../pages/operations/checkerInboxAndTasks/checkerInbox/ManageCheckerInbox";
import DetailCheckerInbox from "../pages/operations/checkerInboxAndTasks/checkerInbox/DetailCheckerInbox";
import ManageLoanApproval from "../pages/operations/checkerInboxAndTasks/ManageLoanApproval";
import ManageLoanDisbursal from "../pages/operations/checkerInboxAndTasks/ManageLoanDisbursal";
import ManageRescheduleLoan from "../pages/operations/checkerInboxAndTasks/ManageRescheduleLoan";
import SearchCheckerInbox from "../pages/operations/checkerInboxAndTasks/checkerInbox/SearchCheckerInbox";
import ManageClientApproval from "../pages/operations/checkerInboxAndTasks/clientApproval/ManageClientApproval";
import ManageBond from "../pages/operations/moneyMarket/bond/ManageBond";
import InterbankPlacement from "../pages/operations/moneyMarket/Interbackplacement/InterbankPlacement";
import NewInterbankPlacement from "../pages/operations/moneyMarket/Interbackplacement/NewInterbankPlacement";
import DetailInterbankPlacement from "../pages/operations/moneyMarket/Interbackplacement/DetailInterbankPlacement";

export default [
  // CHECKER INBOX AND TASKS
  {
    path: "/sms0800",
    component: ManageCheckerInbox,
    isProtected: true,
  },
  {
    path: "/detail-checker-inbox",
    component: DetailCheckerInbox,
    isProtected: true,
  },

  {
    path: "/search-checker-inbox",
    component: SearchCheckerInbox,
    isProtected: true,
  },

  {
    path: "/sms0801",
    component: ManageClientApproval,
    isProtected: true,
  },

  {
    path: "/sms0802",
    component: ManageLoanApproval,
    isProtected: true,
  },
  {
    path: "sms0803",
    component: ManageLoanDisbursal,
    isProtected: true,
  },
  {
    path: "sms0804",
    component: ManageRescheduleLoan,
    isProtected: true,
  },

  // MONEY MARKET
  {
    path: "ope",
    component: ManageBond,
    isProtected: true,
  },
  {
    path: "/operations-interbank-placement",
    component: InterbankPlacement,
    isProtected: true,
  },
  {
    path: "/new-operations-interbank-placement",
    component: NewInterbankPlacement,
    isProtected: true,
  },
  {
    path: "/detail-operations-interbank-placement",
    component: DetailInterbankPlacement,
    isProtected: true,
  },
];
